/**
 * SEO Component for Dynamic Meta Tags
 * Safe addition - doesn't affect existing functionality
 */
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "DevOps Lab Platform | Grras Solutions",
  description = "Master DevOps tools with hands-on labs covering Docker, Kubernetes, Ansible, Bash scripting, and Linux system administration. Practice real-world scenarios in containerized environments.",
  keywords = "DevOps, Docker, Kubernetes, Ansible, Linux, Bash Scripting, Container Management, Infrastructure as Code, Lab Platform, DevOps Training, Grras Solutions",
  image = "/images/og-image.jpg",
  url = typeof window !== 'undefined' ? window.location.href : '',
  type = "website"
}) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Grras Solutions" />
      <link rel="canonical" href={url} />

      {/* Open Graph Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="RHCSA Lab Platform" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="theme-color" content="#1e40af" />
      <meta name="msapplication-TileColor" content="#1e40af" />
    </Helmet>
  );
};

export default SEO;